import React, { Component } from 'react'
import './index.scss'

export default class index extends Component {
  constructor(props){
    super(props)
    this.state = {
      data:[]
    }
  }

  componentWillMount(){
    let data = JSON.parse(decodeURIComponent(sessionStorage.getItem('organization')))
    this.setState({
      data
    })
  }
  componentDidMount(){

  }

  handle_jump = (data) => {
    let children = data.children
    if(children && children.length > 0){
      sessionStorage.setItem("organization",encodeURIComponent(JSON.stringify(children)));
      this.setState({
        data:children
      })
    } else {
      this.props.history.push(`/organization/organization_detail?url=${data.url}`)
    }
  }
  render() {
    const {data} = this.state
    return (
      <div className='listWrapper'>
        <div className="listContent">
          {Array.isArray(data) ?
          this.state.data.map((item,index) => {
            return <div className = 'list_item'
                        onClick={this.handle_jump.bind(this,item)} 
                        key={index}>
                      <div className="iconBox"></div>
                      <div className="contentBox">{item.name}</div>
                      
                  </div>
          })
          :''}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Organization/Organization_list/index.js